import React from 'react';

import { Section, Typography } from '@gogame/components';
import { NumberValueFormatter } from '@gogame/intl-ts';

const Difference = ({ data }) => {
  const { totalSpendUsd, initialSpendUsd } = data;
  return (
    <Section title={'Difference'}>
      <Typography>
        <NumberValueFormatter.Currency value={totalSpendUsd} currency={'usd'} />
        {' - '}
        <NumberValueFormatter.Currency
          value={initialSpendUsd}
          currency={'usd'}
        />
        {' = '}
        <NumberValueFormatter.Currency
          value={totalSpendUsd - initialSpendUsd}
          currency={'usd'}
        />
      </Typography>
    </Section>
  );
};

export default Difference;
